import { Injectable } from '@angular/core';
import { GridColumn } from '@grid/abstractions';
import { DataType } from '@shared/helpers/enums/data-type';
import { get } from 'lodash-es';
import moment, { Moment, MomentInput } from 'moment';

@Injectable()
export class TableDataSortManagerService {
  sortJSONArray<TData>(dataSource: TData[], column: GridColumn): TData[] {
    let sortedJSONArray = dataSource;
    if (column.sortType === 1) {
      sortedJSONArray = dataSource.sort((first: TData, second: TData) =>
        this.ascendentSort(first, second, column)
      );
    } else if (column.sortType === 2) {
      sortedJSONArray = dataSource.sort((first: TData, second: TData) =>
        this.descendentSort(first, second, column)
      );
    } else {
      sortedJSONArray = [];
    }
    return [...sortedJSONArray];
  }

  private ascendentSort<TData>(
    first: TData,
    second: TData,
    options: GridColumn
  ): number {
    if (options.dataType === DataType.String) {
      const f = get(first, options.key),
        s = get(second, options.key);

      return f === s ? 0 : f > s ? 1 : -1;
    } else if (options.dataType === DataType.Date) {
      const a: Moment = moment(
          first[options.key as keyof MomentInput] as string
        ),
        b: Moment = moment(second[options.key as keyof MomentInput] as string);
      return a.isAfter(b) ? 1 : -1;
    }
    return (
      parseFloat(first[options.key as keyof TData] as string) -
      parseFloat(second[options.key as keyof TData] as string)
    );
  }

  private descendentSort<TData>(
    first: TData,
    second: TData,
    options: GridColumn
  ): number {
    if (options.dataType === DataType.String) {
      const f = first[options.key as keyof MomentInput] as string,
        s = second[options.key as keyof MomentInput] as string;

      return f === s ? 0 : f < s ? 1 : -1;
    } else if (options.dataType === DataType.Date) {
      const a: Moment = moment(
          first[options.key as keyof MomentInput] as string
        ),
        b: Moment = moment(second[options.key as keyof MomentInput] as string);
      return b.isAfter(a) ? 1 : -1;
    }
    return (
      parseFloat(second[options.key as keyof TData] as string) -
      parseFloat(first[options.key as keyof TData] as string)
    );
  }
}
